import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, IconButton, Typography } from '@mui/joy';
import { BRAND } from '../brand';

const StockDetailLayout = ({ title, onBack, actions, children }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      bgcolor: 'background.body'
    }}
  >
    <Box
      component="header"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 110,
        bgcolor: 'background.surface',
        borderBottom: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          px: 1,
          py: 1,
          minHeight: 56
        }}
      >
        <IconButton variant="plain" aria-label="Go back" onClick={onBack} sx={{ flexShrink: 0 }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography
          level="title-lg"
          sx={{
            color: BRAND.colors.navy,
            fontWeight: 600,
            flex: 1,
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          {title}
        </Typography>
        {actions && (
          <Box sx={{ display: 'flex', gap: 0.5, flexShrink: 0 }}>
            {actions}
          </Box>
        )}
      </Box>
    </Box>
    <Box
      component="main"
      sx={{
        flex: 1,
        overflow: 'auto',
        px: 1.5,
        py: 2,
        pb: 3
      }}
    >
      {children}
    </Box>
  </Box>
);

export default StockDetailLayout;
